<template>
  <Dialog :show='selecter.active' :okText='selecter.okText' :cancelText='selecter.cancelText' :title='selecter.title'
          @cancel='selecter.resolve(false)' @validate='selecter.resolve(selecter.value)'>

    <component :is='selecter.selector' v-bind='selecter.props'/>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog'

export default {

  name: 'Select',

  components: {
    Dialog
  },

  computed: {
    selecter () {
      return this.$store.state.select
    }
  }
}
</script>
